/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentUserMemo model module.
 * @module model/AgentUserMemo
 * @version 1.0.0
 */
class AgentUserMemo {
    /**
     * Constructs a new <code>AgentUserMemo</code>.
     * @alias module:model/AgentUserMemo
     */
    constructor() { 
        
        AgentUserMemo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentUserMemo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentUserMemo} obj Optional instance to populate.
     * @return {module:model/AgentUserMemo} The populated <code>AgentUserMemo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentUserMemo();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('memo')) {
                obj['memo'] = ApiClient.convertToType(data['memo'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentUserMemo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentUserMemo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['memo'] && !(typeof data['memo'] === 'string' || data['memo'] instanceof String)) {
            throw new Error("Expected the field `memo` to be a primitive type in the JSON string but got " + data['memo']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentUserMemo.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
AgentUserMemo.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
AgentUserMemo.prototype['user_id'] = undefined;

/**
 * @member {String} memo
 */
AgentUserMemo.prototype['memo'] = undefined;

/**
 * @member {Date} created_at
 */
AgentUserMemo.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AgentUserMemo.prototype['updated_at'] = undefined;






export default AgentUserMemo;

